module.exports = __webpack_public_path__ + "static/media/online_orders.e55f1740.svg";